export default __webpack_public_path__ + "static/media/white-2.2cd6314f.png";